import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    resetPassword: en,
  },
  fr: {
    resetPassword: fr,
  },
  pt: {
    resetPassword: pt,
  },
};
